import React, { useEffect, useState, lazy, Suspense } from 'react';
import { View, NotFoundBoundary } from 'react-navi';
function App() {
  return (
    <div className="App">
      <main>
          <NotFoundBoundary render={renderNotFound}>
              <View />
          </NotFoundBoundary>
      </main>
    </div>
  );
}

// Note that create-react-navi-app will always show an error screen when this
// is called. This is because the underlying react-scripts package show
// the error screen when a NotFoundError is thrown, even though it's caught
// by <NotFoundBoundary>. To see the error rendered by this function,
// you'll just need to close the error overlay with the "x" at the top right.
function renderNotFound() {
    return (
        <div className="App-error">
            <h1>404 - Not Found</h1>
        </div>
    );
}


export default App;
